module.exports = __webpack_public_path__ + "static/media/Ranger.bd5df6e1.svg";